export function DonutRing({ parts, size = 96 }: { parts: Array<{ value: number; className: string; label: string }>; size?: number }): JSX.Element {
  const total = parts.reduce((s, p) => s + p.value, 0) || 1;
  const r = size / 2 - 8;
  const c = 2 * Math.PI * r;
  let offset = 0;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90">
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="currentColor" strokeWidth="10" className="text-bg-tertiary" />
      {parts.map((p, i) => {
        const len = (p.value / total) * c;
        const el = (
          <circle key={i} cx={size/2} cy={size/2} r={r} fill="none" strokeWidth="10"
            className={p.className} strokeDasharray={`${len} ${c - len}`} strokeDashoffset={-offset} />
        );
        offset += len;
        return el;
      })}
    </svg>
  );
}
